import { Outlet } from "react-router-dom"
const MainMaterialProgress = () =>{
    return(
        <div className=" w-full h-full">
         <Outlet/>
        </div>
    )
}

export default MainMaterialProgress;